import { render, staticRenderFns } from "./Clave.vue?vue&type=template&id=28244d5b&"
import script from "./Clave.vue?vue&type=script&lang=js&"
export * from "./Clave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports